import { render, staticRenderFns } from "./order-element.vue?vue&type=template&id=483cbe8a&scoped=true&"
import script from "./order-element.vue?vue&type=script&lang=js&"
export * from "./order-element.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483cbe8a",
  null
  
)

export default component.exports